import Controller from '@ember/controller'
import { service } from '@ember/service'
import type { IntlService } from 'ember-intl'
import {
  getResearchReportsViewModel,
  getTeacherGuidesViewModel,
  getCurriculumMapsViewModel,
  getCertificatesViewModel,
} from 'teacher-ui-client/subscription-type/quick-links/contentful-view-models'
import type FastPhonicsQuickLinksRoute from 'teacher-ui-client/subscription-type/quick-links/fast-phonics/route'

interface FastPhonicEntryItem {
  title: string
  description?: string
  subscriptionType: 'Reading' | 'Maths'
  coverUrl?: string
  fileUrl: string
}

export default class FastPhonicsQuickLinksController extends Controller {
  @service intl!: IntlService

  declare model: ModelFor<FastPhonicsQuickLinksRoute>

  get researchReports() {
    return getResearchReportsViewModel(this.model.researchReports)
  }

  get teacherGuides() {
    return getTeacherGuidesViewModel(this.model.teacherGuides)
  }

  get curriculumMaps() {
    return getCurriculumMapsViewModel(this.model.curriculumMaps)
  }

  get certificates() {
    const translationFn = (key: string) => this.intl.t(key)
    return getCertificatesViewModel(this.model.certificates, translationFn)
  }

  get fastPhonicsEntries(): FastPhonicEntryItem[] {
    // @ts-expect-error - entries without fileUrl are filtered out so the return type of this getter with it only defined is correct
    return [...this.researchReports, ...this.teacherGuides, ...this.curriculumMaps, ...this.certificates].filter(
      (entry) => entry?.fileUrl,
    )
  }
}
